/**
 * Settings Store
 *
 * Manages site settings (company info) for the customer portal
 */

import { create } from 'zustand';

interface CompanySettings {
  name: string;
  email: string;
  phone: string;
  address: string;
}

interface SettingsState {
  company: CompanySettings;
  isLoaded: boolean;
  isLoading: boolean;
  error: string | null;
  fetchSettings: () => Promise<void>;
}

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

// Default values (fallback)
const DEFAULT_COMPANY: CompanySettings = {
  name: 'Corporate Gifting Co.',
  email: 'info@corporategifting.com',
  phone: '+91 92171 15485',
  address: 'H.No.944, Block-C, Sushant Lok, Phase 1, Gurugram, Haryana 122001',
};

export const useSettingsStore = create<SettingsState>((set, get) => ({
  company: DEFAULT_COMPANY,
  isLoaded: false,
  isLoading: false,
  error: null,

  fetchSettings: async () => {
    // Don't fetch if already loaded or loading
    if (get().isLoaded || get().isLoading) {
      return;
    }

    set({ isLoading: true, error: null });

    try {
      const response = await fetch(`${API_URL}/content/settings`);
      const data = await response.json();

      if (data.success && data.data) {
        set({
          company: data.data.company,
          isLoaded: true,
          isLoading: false,
        });
      } else {
        set({
          isLoaded: true,
          isLoading: false,
          error: 'Failed to load settings',
        });
      }
    } catch (error) {
      console.error('Failed to fetch settings:', error);
      set({
        isLoaded: true,
        isLoading: false,
        error: 'Failed to load settings',
      });
    }
  },
}));
